module.exports = __webpack_public_path__ + "static/tablet-services-003c9a396a20ff569cc86706d4a97af0.png";